import {
    SET_ORGANISATION_BUSINESS_DEV,
    UPDATE_ORGANISATION_BUSINESS_DEV,
    UPDATE_ORGANISATION_ID_BUSINESS_DEV,
    UPDATE_ORGANISATION_BUSINESS_DEV_ERROR,
    SET_ORGANISATION_BUSINESS_DEV_ERROR,
    SET_ORGANISATION_BUSINESS_DEV_SECTION_AND_ORG_IDS,
    RESET_BUSINESS_DEVELOPMENT
} from "./OrganisationBusinessDevelopmentActions"


export const INITIAL_STATE = {
    section_id: null,
    organisation_id: null,
    data: {},
    errors: {
        // date_of_initial_call: false,
    }
};

const OrganisationActivityReducer = (state = INITIAL_STATE, action) => {

    // eslint-disable-next-line default-case
    switch (action.type) {
        case SET_ORGANISATION_BUSINESS_DEV:
            action.payload['organisation_id'] = state.organisation_id;
            return { ...state, data: { ...state.data, ...action.payload } }
        case UPDATE_ORGANISATION_BUSINESS_DEV:
            action.payload['organisation_id'] = state.organisation_id
            return { ...state, section_id: action.payload.id, data: action.payload };
        case UPDATE_ORGANISATION_ID_BUSINESS_DEV:
            return { ...state, organisation_id: action.payload.id, data: { organisation_id: action.payload.id } };
        case SET_ORGANISATION_BUSINESS_DEV_ERROR:
            return { ...state, errors: action.payload };
        case UPDATE_ORGANISATION_BUSINESS_DEV_ERROR:
            return { ...state, errors: { ...state.errors, [action.payload]: false } };
        case SET_ORGANISATION_BUSINESS_DEV_SECTION_AND_ORG_IDS:
            return { ...state, section_id: action.payload.sectionId, organisation_id: action.payload.organisationId };
        case RESET_BUSINESS_DEVELOPMENT:
            return INITIAL_STATE;
    }
    return state;
};

export default OrganisationActivityReducer;